// src/components/layout/Layout.js - Main layout component for the application
import React from 'react';
import styled from 'styled-components';
import Header from './Header';
import Footer from './Footer';

const Main = styled.main`
  min-height: calc(100vh - 200px); // Ensure the main content area fills the viewport
  padding: var(--spacing-xl) 0;
`;

const Layout = ({ children }) => {
  return (
    <>
      <Header />
      <Main className="container">
        {children}
      </Main>
      <Footer />
    </>
  );
};

export default Layout; 